export default "__VITE_ASSET__Cgcjbao5__"